import React from 'react'

const ProductCard = () => {
    return (
            <div className="bg-black border-2 border-konnect-purple rounded-lg w-80 p-4 h-96">
                <div className="h-full flex">
                    <div className="m-auto space-y-4">
                        <div className="flex justify-center">
                            <div className="w-24">
                                <img src="tailgate.png" />
                            </div>
                        </div>
                        <div className="text-center space-y-4">
                            <p className="text-white text-3xl font-bold text-red-400">Tailgate</p>
                            <p className="text-white text-xl font-semibold">Built to connect tailgaters across a map. Users can create groups, start navigation and gather location data for the others in the group to be shown on the navigation screen. </p>
                        </div>
                    </div>
                </div>
            </div>


    )
}

export default ProductCard
